/**
 * "123 / 500" under a text field with a character limit; turns red when the limit is reached.
 * Pair it with maxLength on the field. Same component as the doctor profile
 * (tiryaq-doctor-pharmacy-app/src/components/dob-input/CharCount.jsx).
 */
const CharCount = ({ value, max, id }) => {
  const count = String(value ?? "").length;
  const atLimit = count >= max;
  return (
    <small
      id={id}
      aria-live="polite"
      style={{
        display: "block",
        marginTop: 4,
        fontSize: 12,
        textAlign: "end",
        color: atLimit ? "#dc2626" : "#6b7280",
      }}
    >
      {count} / {max}
    </small>
  );
};

export default CharCount;
